import { render, staticRenderFns } from "./ActionHeaderSeparator.vue?vue&type=template&id=426fb0b7&scoped=true"
var script = {}
import style0 from "./ActionHeaderSeparator.vue?vue&type=style&index=0&id=426fb0b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426fb0b7",
  null
  
)

export default component.exports